import axios from "axios"

const PaymentResponse = () => {
  // const getRes = async () => {
  //   const formData = new FormData();
  //   formData.append('merchantID', merchantID);
  //   formData.append('merchantTxnNo', merchantTxnNo);
  //   formData.append('originalTxnNo', originalTxnNo);
  //   formData.append('transactionType', transactionType);
  //   formData.append('amount', amount);
  //   const response = await axios.post("https://pgpay.icicibank.com/pg/api/command", formData, { headers: formData.getHeaders() })
  // }
  return (
    <div>
      Getting Payment Response......
    </div>
  )
}

export default PaymentResponse
